var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.72 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.48,16.35l-3.41-3.95c1.08-1.22,1.73-2.75,1.85-4.41.14-1.99-.5-3.92-1.81-5.42C11.79,1.06,9.98.16,7.99.02c-2-.15-3.92.5-5.42,1.81C-.54,4.54-.87,9.26,1.83,12.37c1.31,1.51,3.13,2.41,5.12,2.55.18.01.36.02.53.02,1.46,0,2.87-.43,4.08-1.23l3.4,3.95c.2.23.48.35.76.35.23,0,.46-.08.65-.24.42-.36.46-.99.1-1.41Zm-9.39-3.42c-1.46-.1-2.79-.77-3.75-1.87-1.98-2.28-1.74-5.74.54-7.71,1.03-.9,2.31-1.34,3.58-1.34,1.53,0,3.05.64,4.13,1.88,1.98,2.28,1.74,5.74-.54,7.71-1.1.96-2.5,1.43-3.97,1.33Z",
    fill: "#624de3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.0a499589e0ef1b76170d0dff77b6db37.svg";
export { ForwardRef as ReactComponent };